import React from 'react';

import styles from '../FileViewer.module.css';

type TextViewerProps = {
  content: string;
};

export const TextViewer: React.FC<TextViewerProps> = ({ content }) => {
  return <pre className={styles.textContainer}>{content}</pre>;
};
